// extracted by mini-css-extract-plugin
module.exports =  {"highlighted":"_93444fe79c--highlighted--TzjBZ","price-container":"_93444fe79c--price-container--atayL","strikethrough":"_93444fe79c--strikethrough--K0cwg"};